import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Noticia } from '@/shared/dtos/noticia';
import DxTextBox from 'devextreme-vue/text-box';
import DxSelectBox from 'devextreme-vue/select-box';
import { itiHttpService } from '@/iti-core-vue/services/iti-http-service';
import { API } from '@/shared/api';
import { ItiIconButton, ItiVHeader } from '@/iti-core-vuetify';
import noticiasModule from '@/store/modules/noticias.module'
import { itiMessageService } from '@/iti-core-vue';

@Component({
    components: {
        ItiIconButton,
        DxTextBox,
        DxSelectBox,
    },
})

export default class NoticiasWebLista extends Vue {
    public search = '';
    
    public itemsPerPage = 6;
    public itemsPerPageArray= [2, 4, 6, 8, 10, 12, 14, 16, 18];

    public sortDesc = false;
    public page = 1;
    public sortBy = 'Titular'; 
    public keys =  ['Titular', 'Autor', 'Instituto', 'Categoria'];
    public filter = {};

    public async created() {
        document.documentElement.scrollTop;
    }

    public mounted() {
        noticiasModule.getNoticias().then().catch(() => { itiMessageService.toast(this.$tc('mensajes-algoritmos.info-error'), 'error', 2000); });
    }

    public get noticiasList() {
        return noticiasModule.noticias;
    }

    public fecha(noticia: Noticia) {
        return  noticia.fechaDePublicacion.toString().substring(0,10) + "   " + noticia.fechaDePublicacion.toString().substring(12,19);   
     }

    public get numberOfPages() {
        return Math.ceil(this.noticiasList.length / this.itemsPerPage);
    }

    public get filteredKeys() {
        return this.keys.filter(key => key !== 'Titular')
    }

    public nextPage () {
        if (this.page + 1 <= this.numberOfPages) this.page += 1
    }

    public formerPage () {
        if (this.page - 1 >= 1) this.page -= 1
    }

    public  updateItemsPerPage (number: any) {
        this.itemsPerPage = number
    }


    public goTo(noticia: Noticia) {
        var id = this.noticiasList.findIndex(e => e.titular == noticia.titular) + 1;
        noticiasModule.getNoticiaById(id); 
        this.$router.push({ name: 'NoticiaCompleta', params: { id: id.toString() } })
    }
}